import React from 'react';
import BotLogsAccordion from '../botLogsAccordion/BotLogsAccordion';
import './botLogsGroup.scss';


interface BotLogsGroupProps {
    messages: any[];
    startIndex: number;
    isStreaming: boolean;
}

const BotLogsGroup: React.FC<BotLogsGroupProps> = ({ messages, startIndex, isStreaming }) => {
    const logGroup: string[] = [];
    let isAccordionCollapsed = false;

    for (let i = startIndex; i < messages?.length; i++) {
        const msg = messages[i];
        if (msg?.contentType === 'display' && msg?.displayLogs) {
            const trimmedLog = msg.displayLogs.trim();
            // if (trimmedLog.toLowerCase() !== 'done.') {
                logGroup.push(trimmedLog);
            // }
        } else {
            isAccordionCollapsed = true;
            break;
        }
    }

    if (logGroup.length === 0) return null;

    return (
        <div className="bot-logs-group">   
            {/* <div className="bot-icon">
                <img className="svg" src="assets/icon/logoIcon.svg" alt="Ionic logo" />
            </div> */}
            <div className="bot-bubble">
                <BotLogsAccordion logs={logGroup} isAccordionCollapsed={isAccordionCollapsed} isStreaming={isStreaming} />
            </div>
        </div>
    );
};

export default BotLogsGroup;
